// =============================================================================
// Configuration Globale
// =============================================================================

/**
 * Délais et durées
 */
export const TIMEOUTS = {
  /** Délai pour le regroupement des actions (en ms) */
  ACTION_GROUPING: 5000,
  /** Durée d'affichage des notifications (en ms) */
  NOTIFICATION_DISPLAY: 5000,
  /** Durée par défaut du cache (en ms) */
  DEFAULT_CACHE_TTL: 5 * 60 * 1000, // 5 minutes
  /** Intervalle de nettoyage du cache (en ms) */
  CACHE_CLEANUP_INTERVAL: 60000, // 1 minute
} as const;

/**
 * États des marqueurs
 */
export const MARKER_STATUS = {
  ACTIVE: 'active',
  PENDING: 'pending',
  CLOSED: 'closed',
} as const;

export type MarkerStatus = typeof MARKER_STATUS[keyof typeof MARKER_STATUS];

/**
 * Types de notifications
 */
export const NOTIFICATION_TYPES = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
} as const;

export type NotificationType = typeof NOTIFICATION_TYPES[keyof typeof NOTIFICATION_TYPES];

/**
 * Niveaux de sévérité pour les erreurs de carte
 */
export const MAP_ERROR_SEVERITY = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
} as const;

export type MapErrorSeverity = typeof MAP_ERROR_SEVERITY[keyof typeof MAP_ERROR_SEVERITY];

/**
 * États des actions
 */
export const ACTION_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
} as const;

export type ActionStatus = typeof ACTION_STATUS[keyof typeof ACTION_STATUS];

// Note: Les configurations spécifiques à la carte (zoom, centre, etc.) restent dans mapConfig.ts
// car elles sont spécifiques à ce composant et pourraient nécessiter des ajustements différents
// selon l'environnement

